import GroupsAPI, { IGroupPost } from 'api/GroupsAPI';
import { createPaginatedLookupStore } from 'stores/index';

export const GroupFeedStore = createPaginatedLookupStore<{ groupId: number }, IGroupPost>(
  ({ groupId }, page) => GroupsAPI.listGroupFeed(groupId, page),
  ({ groupId }) => groupId.toString(),
);
